// Generated by ReScript, PLEASE EDIT WITH CARE

import * as UserRoles from "../../types/workspace/UserRoles.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as CookieUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/CookieUtils.bs.js";

function fetchUserRoles(param) {
  CookieUtils$Catalyst.setCookie("user_roles=tele_agent&dispatch_agent&adjust_fare_page_access&geomap_access&admin_roles_controller&control_driver_suspension_deletion");
  var user_roles_cookie = CookieUtils$Catalyst.getCookie("user_roles");
  return DeccoUtils$Catalyst.resolveResult(UserRoles.t_decode(user_roles_cookie), "WorkspaceRepo.re");
}

var WorkSpaceRepo = {
  fetchUserRoles: fetchUserRoles
};

export {
  WorkSpaceRepo ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
